<template>
  <div class="btn-group toggle-btn">
    <vs-button
            v-for="opt in options"
            @click="change(opt.value)"
            :class="isSelected(opt.value) ? 'active toggle-button' : 'toggle-button'"
            type="line"
    >{{ opt.text }}</vs-button>
  </div>
</template>

<script>
export default {
  name: "ButtonToggle",
  props: {
    value: {
      required: true,
      default: null
    },
    options: {
      type: Array,
    }
  },
  methods: {
    change(value) {
      this.$emit('input', value);
    },
    isSelected(value) {
      return value === this.value;
    },
  },
}
</script>

<style lang="scss">
.toggle-btn {
  .toggle-button.vs-button-primary {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-right: 1.2rem;

    &.active {
      border-bottom: 2px solid black !important;
    }
  }
}
</style>
